
import { Form, Input } from 'decorator-form';
import { TypographyStylesConfig, typographyStylesInput } from '../common/TypographyStylesConfig';
import { ColumnHeaderStylesConfig, columnHeaderStylesInput } from './ColumnHeaderStylesConfig';

@Form({title: "Column Header View Config"})
export default class ColumnHeaderConfig {

	@Input({type: typographyStylesInput, title: "Text Styles"})
	public typography: TypographyStylesConfig;

	@Input({type: columnHeaderStylesInput, title: "Default State"})
	public defaultState: ColumnHeaderStylesConfig;

	@Input({type: columnHeaderStylesInput, title: "Hover State"})
	public hoverState: ColumnHeaderStylesConfig;

}



// WEBPACK FOOTER //
// ./src/common/views/columnHeader/ColumnHeaderConfig.ts